import coreLogger from '@adc/logger';
import { BaseNotifier } from './baseNotifier';
const logger = coreLogger.forModule('DEBUG_NOTIFIER');
class DebuggingNotifier extends BaseNotifier {
    initialize() {
        super.initialize();
    }
    open(notification) {
        logger.info(notification);
    }
    close() {
        logger.info('debugger: close');
    }
}
export { DebuggingNotifier };
//# sourceMappingURL=debuggingNotifier.js.map